import { createWebHistory, createRouter } from "vue-router";
import Layout from "@/layout/index.vue";

export const constantRoutes = [
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "/home",
        name: "Home",
        component: () => import("@/views/home/index.vue"),
      },
      {
        path: "/dataConstruction",
        name: "DataConstruction",
        component: () => import("@/views/dataConstruction/index.vue"), // 路由懒加载
      },
      {
        path: "/dataApplication",
        name: "DataApplication",
        component: () => import("@/views/dataApplication/index.vue"),
      },
      {
        path: "/dataset",
        name: "Dataset",
        component: () => import("@/views/dataset/index.vue"),
      },
      {
        path: "/recruitment",
        name: "Recruitment",
        component: () => import("@/views/recruitment/index.vue"),
      },
      {
        path: "/recruitmentDetail",
        name: "RecruitmentDetail",
        component: () => import("@/views/recruitment/recruitmentDetail.vue"),
      },
      {
        path: "/aboutUs",
        name: "AboutUs",
        component: () => import("@/views/aboutUs/index.vue"),
      },
    ],
    redirect: "/home",
  },
  {
    path: "/joinUs",
    name: "JoinUs",
    component: () => import("@/views/joinUs/index.vue"),
    children: [
      {
        path: "/experienced",
        name: "Experienced",
        component: () => import("@/views/joinUs/pages/experienced.vue"),
      },
      {
        path: "/companyNews",
        name: "CompanyNews",
        component: () => import("@/views/joinUs/pages/companyNews.vue"),
      },
      {
        path: "/socialRecruitment",
        name: "SocialRecruitment",
        component: () => import("@/views/joinUs/pages/socialRecruitment.vue"),
      },
      {
        path: "/campusRecruitment",
        name: "CampusRecruitment",
        component: () => import("@/views/joinUs/pages/campusRecruitment.vue"),
      },
      {
        path: "/detail",
        name: "Detail",
        component: () => import("@/views/joinUs/pages/detail.vue"),
      },
    ],
    redirect: "/experienced",
  },
  {
    path: "/:pathMatch(.*)",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes,
});
export default router;
